import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import {
  ResourceHeading2,
  ResourceParagraph,
} from 'components/theme/Typography/ResourceTypography';
import { PrimaryButton } from 'components/theme/Button';
import { Header } from 'features/GuestReschedule/components/Layout';
import { Wrapper } from 'components/theme/Wrapper';
import useGuestReschedule from 'features/GuestReschedule/hooks/useGuestReschedule';
import styled from 'styled-components';
import { formatSessionLabelWithTimezone } from 'features/GuestReschedule/formatSessionLabelWithTimezone';
import useInitGuestReschedule from 'features/GuestReschedule/hooks/useInitGuestReschedule';
import { useTranslation } from 'react-i18next';

const GuestRescheduleSuccessPage: FC = () => {
  const { replace } = useHistory();
  const { t } = useTranslation();

  useInitGuestReschedule();

  const {
    cartId,
    token,
    selectedRescheduleDate,
    bookingSelected,
    resetRescheduleState,
  } = useGuestReschedule();

  const rescheduledDate =
    selectedRescheduleDate || bookingSelected?.eventStartDateTime;

  const handleClick = () => {
    resetRescheduleState();
    replace({
      pathname: `/carts/${cartId}/guest-reschedule`,
      search: `?token=${token}`,
    });
  };

  if (!bookingSelected || !rescheduledDate) {
    return null;
  }

  return (
    <Wrapper>
      <Container>
        <Header>
          <div style={{ textAlign: 'center' }}>
            <StyledCheckIcon
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              fill="none"
              viewBox="0 0 48 48"
            >
              <path
                fill="#000"
                fillOpacity="0.8"
                fillRule="evenodd"
                d="m18 33.102 19.551-19.551 1.697 1.697-20.4 20.4a1.2 1.2 0 0 1-1.697 0l-10.8-10.8L8.05 23.15z"
                clipRule="evenodd"
              />
            </StyledCheckIcon>
          </div>

          <ResourceHeading2
            fontSize="32px"
            className="title"
            style={{ textAlign: 'center' }}
          >
            {t('reservationRescheduled')}
          </ResourceHeading2>
          <ResourceParagraph
            className="subtitle"
            fontSize="16px"
            opacity="0.7"
            fontWeight="400"
            lineHeight="20px"
          >
            {t('yourReservationWasRescheduledTo')}{' '}
            {formatSessionLabelWithTimezone(
              rescheduledDate as unknown as string,
              bookingSelected.eventSessionDurationInMinutes,
              bookingSelected.experienceTimeZoneId,
            )}
            .
          </ResourceParagraph>
        </Header>
        <PrimaryButton
          style={{ width: '230px', height: '50px', marginTop: '16px' }}
          onClick={handleClick}
        >
          {t('viewExperiences')}
        </PrimaryButton>
      </Container>
    </Wrapper>
  );
};

export default GuestRescheduleSuccessPage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  text-align: center;
  gap: 24px;
  padding: 0 16px;
`;

const StyledCheckIcon = styled.svg`
  display: block;
  margin: 0 auto 8px auto;
`;
